// socket.js
import { io } from "socket.io-client";

const socket = io("http://192.168.1.10:8080", {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  timeout: 10000,
  forceNew: false   // IMPORTANT → prevents duplicate sockets
});

export default socket;
